import { Events } from "@graylog/server-api";
import * as URLUtils from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { additionalAttributes } from "components/events/Constants";
import parseTimerangeFilter from "components/common/PaginatedEntityTable/parseTimerangeFilter";
const url = URLUtils.qualifyUrl("/events/search");
export const parseTypeFilter = (alert) => {
  switch (alert) {
    case "true":
      return "only";
    case "false":
      return "exclude";
    default:
      return "include";
  }
};
const allTime = { type: "relative", range: 0 };
export const parseFilters = (filters, defaultTimerange = allTime) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const result = {
    filter: {
      extra_filters: void 0,
      aggregation_timerange: void 0,
      id: void 0,
      event_definitions: void 0,
      priority: void 0,
      key: void 0,
      alerts: parseTypeFilter((_a = filters == null ? void 0 : filters.get("alert")) == null ? void 0 : _a[0])
    },
    timerange: void 0
  };
  result.timerange = parseTimerangeFilter((_b = filters.get("timestamp")) == null ? void 0 : _b[0], defaultTimerange);
  const timerange_start = (_c = filters.get("timerange_start")) == null ? void 0 : _c[0];
  if (timerange_start) {
    result.filter.aggregation_timerange = parseTimerangeFilter(timerange_start, defaultTimerange);
  }
  if (((_d = filters.get("key")) == null ? void 0 : _d.length) > 0) {
    result.filter.key = filters.get("key");
  }
  if (((_e = filters.get("event_definition_id")) == null ? void 0 : _e.length) > 0) {
    result.filter.event_definitions = filters.get("event_definition_id");
  }
  if (((_f = filters.get("priority")) == null ? void 0 : _f.length) > 0) {
    result.filter.priority = filters.get("priority");
  }
  if (((_g = filters.get("id")) == null ? void 0 : _g.length) > 0) {
    result.filter.id = filters.get("id");
  }
  if (((_h = filters.get("part_of_detection_chain")) == null ? void 0 : _h.length) > 0) {
    result.filter.part_of_detection_chain = filters.get("part_of_detection_chain")[0];
  }
  return result;
};
export const getConcatenatedQuery = (query, streamId) => {
  if (!streamId) return query;
  if (streamId && !query) return `source_streams:${streamId}`;
  return `(${query}) AND source_streams:${streamId}`;
};
export const defaultTimeRange = { type: "relative", range: 30 * 86400 };
export const fetchEventsHistogram = async (searchParams) => {
  const { timerange, filter } = parseFilters(searchParams.filters, defaultTimeRange);
  return Events.histogram({
    query: searchParams.query,
    page: searchParams.page,
    per_page: searchParams.pageSize,
    sort_by: searchParams.sort.attributeId,
    sort_direction: searchParams.sort.direction,
    sort_unmapped_type: void 0,
    filter,
    timerange
  }).then((results) => ({ timerange, results }));
};
export const keyFn = (searchParams) => ["events", "search", searchParams];
const fetchEvents = (searchParams, streamId) => {
  const { filter, timerange } = parseFilters(searchParams.filters, defaultTimeRange);
  return fetch("POST", url, {
    query: getConcatenatedQuery(searchParams.query, streamId),
    page: searchParams.page,
    per_page: searchParams.pageSize,
    sort_by: searchParams.sort.attributeId,
    sort_direction: searchParams.sort.direction,
    timerange,
    filter
  }).then(({ events, total_events, parameters, context }) => ({
    attributes: additionalAttributes,
    list: events.map(({ event }) => event),
    pagination: { total: total_events, page: parameters.page, per_page: parameters.per_page, count: events.length },
    meta: {
      context
    }
  }));
};
export default fetchEvents;
